export const UPDATE_EVENTS_FILTERS = "UPDATE_EVENTS_FILTERS";
